import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import * as React from 'react';

const useApiUrl = () => {
    let [apiUrl, setApiUrl] = React.useState<string>('');

    React.useEffect(() => {
        if (typeof document !== 'undefined') {
            apiUrl = window.appConfig.apiUrl;
        }
    }, []);

    return apiUrl;
};

const SelectablePhotographersSection = ({
    availablePhotographersLabel,
    selectedPhotographer,
    onSelectPhotographer,
    photographers,
    toggleStyling,
    onSelectPhotographerClick,
    openPhotographerPortfolioModal,
    portfolioButtonLabel
}) => {
    let apiUrl = useApiUrl();

    return (
        <FormControl sx={{ width: '100%', marginBottom: '20px' }}>
            <FormLabel
                aria-label={'available-photographers'}
                id="radio-buttons-group-label"
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '10px',
                    textTransform: 'uppercase',
                    fontWeight: 400,
                    fontSize: '1.4rem',
                    lineHeight: '32px'
                }}
            >
                {availablePhotographersLabel}
            </FormLabel>
            <RadioGroup
                aria-labelledby="radio-buttons-group-label"
                value={selectedPhotographer != undefined ? selectedPhotographer : ''}
                onChange={onSelectPhotographer}
                name="radio-buttons-group"
            >
                {photographers.map((photographer, index) => {
                    let isActive = toggleStyling === index;

                    return (
                        <Box
                            role={'button'}
                            aria-label={'selectable-photographer'}
                            onClick={() => onSelectPhotographerClick(photographer.id, index)}
                            key={photographer.id}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                borderRadius: '4px',
                                padding: '10px 0',
                                border: isActive
                                    ? '1px solid rgba(33, 150, 243, 0.5)'
                                    : '1px solid black',
                                backgroundColor: isActive ? 'rgba(33, 150, 243, 0.1)' : ''
                            }}
                        >
                            <Box sx={{ padding: ' 0px 8px 0px 12px' }}>
                                <Avatar
                                    alt={photographer.name}
                                    src={`${apiUrl}/file/${photographer.profileImageReference}`}
                                />
                            </Box>
                            <Typography
                                variant={'h1'}
                                sx={{
                                    fontWeight: 500,
                                    fontSize: '16px',
                                    fontFamily: 'Gilroy',
                                    maxWidth: '180px'
                                }}
                            >
                                {photographer.name}
                            </Typography>
                          <Box sx={{ flex: '1 auto' }}/>
                            <Button
                                aria-label={'portfolio-button'}
                                sx={{
                                    border: '1px solid #E0E0E0',
                                    textTransform: 'none',
                                    padding: '5px 10px'
                                }}
                                variant={'outlined'}
                                endIcon={
                                    <ImageOutlinedIcon sx={{ color: 'rgba(0, 0, 0, 0.54)' }} />
                                }
                                onClick={(event) =>
                                    openPhotographerPortfolioModal(
                                        event,
                                        photographer.name,
                                        photographer.id
                                    )
                                }
                            >
                                {portfolioButtonLabel}
                            </Button>
                            <FormControlLabel
                                aria-label={'select-photographer-button-' + index}
                                sx={{
                                    '&.MuiFormControlLabel-root': {
                                        marginLeft: 0,
                                        marginRight: 0
                                    }
                                }}
                                value={photographer.id}
                                control={
                                    <Radio
                                        sx={{
                                            '&.Mui-checked': {
                                                color: '#2196F3'
                                            }
                                        }}
                                    />
                                }
                                label=""
                            />
                        </Box>
                    );
                })}
            </RadioGroup>
        </FormControl>
    );
};
export default SelectablePhotographersSection;
